(function () {
  let tgdApprovalWarningVisible = false;

  function getTgdApprovalData() {
    const approvalCheckboxes = Array.from(
      document.querySelectorAll('[data-tgd-tech-pack-approval]')
    );

    const hasApprovalCheckboxes = approvalCheckboxes.length > 0;

    const allApproved =
      !hasApprovalCheckboxes ||
      approvalCheckboxes.every(function (checkbox) {
        return checkbox.checked;
      });

    return {
      hasApprovalCheckboxes: hasApprovalCheckboxes,
      allApproved: allApproved
    };
  }

  function getTgdCheckoutButtons() {
    return Array.from(
      document.querySelectorAll('#checkout, #CartDrawer-Checkout')
    );
  }

  function ensureTgdCheckoutMessage(button) {
    const ctaWrapper = button.closest('.cart__ctas');

    if (!ctaWrapper || !ctaWrapper.parentElement) return null;

    const messageContainer = ctaWrapper.parentElement;

    let message = messageContainer.querySelector(
      '.tgd-tech-pack-approval-message'
    );

    if (!message) {
      message = document.createElement('div');
      message.className = 'tgd-tech-pack-approval-message';
      message.textContent =
        'Please review and approve all Tech Packs before checkout.';

      message.style.display = 'none';
      message.style.width = '100%';
      message.style.margin = '0 0 5px';
      message.style.padding = '5px 14px';
      message.style.borderRadius = '12px';
      message.style.background = '#f1efff';
      message.style.color = '#48474fff';
      message.style.fontSize = '13px';
      message.style.fontWeight = '700';
      message.style.lineHeight = '1.35';
      message.style.textAlign = 'right';
      message.style.letterSpacing = '0.02em';

      messageContainer.insertBefore(message, ctaWrapper);
    }

    return message;
  }

  function updateTgdApprovalHighlight(shouldHighlight) {
    document
      .querySelectorAll('[data-tgd-tech-pack-approval]')
      .forEach(function (checkbox) {
        const label = checkbox.closest('.tgd-cart-tech-pack__approval');

        if (!label) return;

        const isActive = shouldHighlight && !checkbox.checked;

        label.style.background = isActive ? '#f1efff' : '';
        label.style.color = isActive ? '#48474fff' : '';
        label.style.borderRadius = isActive ? '12px' : '';
        label.style.padding = isActive ? '5px 14px' : '';
        label.style.marginTop = isActive ? '14px' : '';
        label.style.fontWeight = isActive ? '700' : '';
        label.style.lineHeight = isActive ? '1.35' : '';
        label.style.letterSpacing = isActive ? '0.02em' : '';
      });
  }

  function showTgdCheckoutMessage() {
    getTgdCheckoutButtons().forEach(function (button) {
      const message = ensureTgdCheckoutMessage(button);

      if (message) {
        message.style.display = 'block';
      }
    });

    tgdApprovalWarningVisible = true;
    updateTgdApprovalHighlight(true);
  }

  function hideTgdCheckoutMessage() {
    document
      .querySelectorAll('.tgd-tech-pack-approval-message')
      .forEach(function (message) {
        message.style.display = 'none';
      });

    tgdApprovalWarningVisible = false;
    updateTgdApprovalHighlight(false);
  }

  function updateTgdTechPackApprovalState() {
    const approvalData = getTgdApprovalData();
    const checkoutButtons = getTgdCheckoutButtons();

    checkoutButtons.forEach(function (button) {
      button.setAttribute('formnovalidate', 'formnovalidate');

      if (!approvalData.hasApprovalCheckboxes) {
        button.removeAttribute('aria-disabled');
        button.classList.remove('tgd-checkout-blocked');
        button.style.opacity = '';
        button.style.cursor = '';
        return;
      }

      button.disabled = false;

      button.setAttribute(
        'aria-disabled',
        approvalData.allApproved ? 'false' : 'true'
      );

      button.classList.toggle(
        'tgd-checkout-blocked',
        !approvalData.allApproved
      );

      button.style.opacity = approvalData.allApproved ? '' : '0.45';
      button.style.cursor = approvalData.allApproved ? '' : 'not-allowed';
    });

    document
      .querySelectorAll('.additional-checkout-buttons')
      .forEach(function (container) {
        container.style.pointerEvents = approvalData.allApproved ? '' : 'none';
        container.style.opacity = approvalData.allApproved ? '' : '0.45';
      });

    if (approvalData.allApproved) {
      hideTgdCheckoutMessage();
    }

    if (tgdApprovalWarningVisible && !approvalData.allApproved) {
      updateTgdApprovalHighlight(true);
    }
  }

  function getTgdApprovalStorageKey(checkbox) {
    return 'tgd_tech_pack_approved_' + checkbox.dataset.customizationId;
  }

  function restoreTgdApprovalState() {
    document
      .querySelectorAll('[data-tgd-tech-pack-approval]')
      .forEach(function (checkbox) {
        const storageKey = getTgdApprovalStorageKey(checkbox);

        checkbox.checked = sessionStorage.getItem(storageKey) === 'true';
      });
  }

  document.addEventListener(
    'click',
    function (event) {
      const checkoutButton = event.target.closest(
        '#checkout, #CartDrawer-Checkout'
      );

      if (!checkoutButton) return;

      const approvalData = getTgdApprovalData();

      if (
        approvalData.hasApprovalCheckboxes &&
        !approvalData.allApproved
      ) {
        event.preventDefault();
        event.stopPropagation();

        showTgdCheckoutMessage();
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target.closest('#cart, #CartDrawer-Form');

      if (!form) return;

      const approvalData = getTgdApprovalData();

      if (
        approvalData.hasApprovalCheckboxes &&
        !approvalData.allApproved
      ) {
        event.preventDefault();
        event.stopPropagation();

        showTgdCheckoutMessage();
      }
    },
    true
  );

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-tgd-tech-pack-approval]')) {
      return;
    }

    const storageKey = getTgdApprovalStorageKey(event.target);

    sessionStorage.setItem(
      storageKey,
      event.target.checked ? 'true' : 'false'
    );

    updateTgdTechPackApprovalState();
  });

  document.addEventListener('DOMContentLoaded', function () {
    restoreTgdApprovalState();
    updateTgdTechPackApprovalState();

    const observer = new MutationObserver(function () {
      restoreTgdApprovalState();
      updateTgdTechPackApprovalState();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
})();